import Toolbar from "components/Toolbar";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import TransactionDetails from "./TransactionDetails";

export default function TransactionDetailsMobile() {
  const { t } = useTranslation();
  const { transactionId } = useParams();

  return (
    <>
      <Toolbar title={t('O_DETAILS')} showBackBtn={true} />
      <TransactionDetails transactionId={transactionId} />
    </>
  );
}
